import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsUsersSubscriptionAccessController from 'lumen/controllers/hotel/settings/users/subscription-access';
import type { Transition } from 'lumen/services/transition';

export default class HotelSettingsUsersSubscriptionAccessRoute extends Route {
  queryParams = {
    userId: { refreshModel: true },
    userEmail: { refreshModel: false },
  };

  @service declare router: Services['router'];

  beforeModel(transition: Transition): void {
    const userId = transition.to?.queryParams?.['userId'];

    if (!userId) {
      this.router.transitionTo('hotel.settings.users');
    }
  }

  // Without an overridden model hook, Ember treats query-param-only
  // (refreshModel) transitions as a no-op and skips setupController, so
  // switching userId would update the URL but never reload the modal.
  // Returning a fresh object on every call is enough to make Ember
  // re-run setupController each time.
  model(): object {
    return {};
  }

  setupController(
    controller: HotelSettingsUsersSubscriptionAccessController,
    model: unknown,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    void controller.resetAndLoad();
  }
}
